import { ShortcutBase } from './ShortcutBase';
import { ScenarioStatisticQuery } from '../../ScenarioStatisticQuery';
import { ShortcutType, IQueryShortcutOptions, TRootOptionsShortcutFnReturn } from '../../../models/query/scenarioStatistics/shortcuts';
import { ScenarioStatisticShortcut, ScenarioStatisticTarget } from '../../../models/query/scenarioStatistics';
import { IQueryPortfoliosBarChartDataOptionsLabels } from '../../../models/query/scenarioStatistics/IQueryPortfoliosBarChartDataOptionsLabels';
import { replacePlaceholders } from '../../../utils';

export class PortfoliosBarChartDataShortcut extends ShortcutBase {
	constructor(scenarioStatisticQuery: ScenarioStatisticQuery) {
		super(ScenarioStatisticShortcut.portfoliosBarChartData, ShortcutType.rootOptions, scenarioStatisticQuery);
	}
	getLabels = (rawOverrides: IQueryPortfoliosBarChartDataOptionsLabels = {}): Required<IQueryPortfoliosBarChartDataOptionsLabels> => {
		const overrides = { ...rawOverrides };
		const response: Required<IQueryPortfoliosBarChartDataOptionsLabels> = {
			periodAll: 'ALL',
			periodMonth: '{value}M',
			periodYear: '{value}Y',
			periodMonths: '{value}M',
			periodYears: '{value}Y',
		};
		if (overrides.periodMonths && !overrides.periodMonth) {
			overrides.periodMonth = overrides.periodMonths;
		}
		if (overrides.periodYears && !overrides.periodYear) {
			overrides.periodYear = overrides.periodYears;
		}
		Object.assign(response, overrides);
		return response;
	}
	getRootOptions(shortcutOptions: IQueryShortcutOptions) {
		const { options = {}, periods = {}, portfolios = {} } = shortcutOptions;
		const workingShortcutOptions = { ...shortcutOptions };
		if (!workingShortcutOptions.periods) {
			workingShortcutOptions.periods = {};
		}
		workingShortcutOptions.periods.target = ScenarioStatisticTarget.collection;
		if (!workingShortcutOptions.periods.collectionOptions) {
			workingShortcutOptions.periods.collectionOptions = {};
		}
		const { data, labels: rawLabels } = options.portfoliosBarChartData || {};
		const labels = this.getLabels(rawLabels);
		workingShortcutOptions.periods.collectionOptions.injectId = {
			enabled: true,
			transform: {
				key: {
					staticValue: 'period',
				},
				value: {
					transforms: [
						{
							transformOptionsType: 'alias',
							aliases: [
								{
									source: 'all',
									replacement: labels.periodAll,
								},
							],
						},
					],
				},
			},
		};
		// Add aliases for the first 11 months
		for (let i = 1; i <= 11; i++) {
			workingShortcutOptions.periods.collectionOptions.injectId.transform.value.transforms[0].aliases.push({
				source: i.toString(),
				replacement: replacePlaceholders({ value: i }, labels.periodMonth),
				fullMatchOnly: true,
			});
		}
		// Add aliases for 30 years
		for (let i = 1; i <= 30; i++) {
			workingShortcutOptions.periods.collectionOptions.injectId.transform.value.transforms[0].aliases.push({
				source: (i * 12).toString(),
				replacement: replacePlaceholders({ value: i }, labels.periodYear),
				fullMatchOnly: true,
			});
		}
		if (!workingShortcutOptions.portfolios) {
			workingShortcutOptions.portfolios = {};
		}
		workingShortcutOptions.portfolios.target = ScenarioStatisticTarget.collection;
		if (!workingShortcutOptions.portfolios.collectionOptions) {
			workingShortcutOptions.portfolios.collectionOptions = {};
		}
		workingShortcutOptions.portfolios.collectionOptions.pivotToObject = {
			enabled: true,
			transform: {
				key: {
					prefix: 'portfolio',
				},
			},
		};
		const response: TRootOptionsShortcutFnReturn = this.scenarioStatisticQuery.shortcuts.portfolios.getRootOptions(
			{
				...workingShortcutOptions,
				options: {
					portfolios: {
						key: 'portfolio',
						options: {
							portfolio: data,
						},
					},
				},
			},
		);
		return response;
	}
}